import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
} from "@angular/forms";
import { CatalogoService } from "src/app/services/catalogo.service";
import { Observable, from } from "rxjs";
import { MapUtils } from "../../../../shared/utils/map-utils";
import { Usuario } from "src/app/models/entities/usuario";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { UsuarioSesionDTO } from "src/app/models/dtos/usuario-sesion-dto";
import { take } from "rxjs/operators";
import { Estado } from "src/app/models/entities/estado";
import { DateUtils } from "src/app/shared/utils/date-utils";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Segmento } from "src/app/models/entities/segmento";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { LoaderService } from "src/app/services/loader.service";
import { AlertasService } from "src/app/services/alertas.service";
import { Coordenada } from "src/app/models/entities/coordenada";
import { SegmentoService } from "src/app/services/segmento.service";
import {} from "googlemaps";
import { MapsAPILoader } from "@agm/core";
declare var JSZip: any;
declare var toGeoJSON: any;
declare const google: any;

@Component({
  selector: "levantamiento-obra",
  templateUrl: "./levantamiento-obra.component.html",
  styleUrls: ["./levantamiento-obra.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LevantamientoObraComponent implements OnInit {
  public usuarioEnSesion: UsuarioSesionDTO;
  public form: FormGroup;
  public archivos: any[] = [];
  public idiomaCalendario: any;
  public anioActual: number = new Date().getFullYear();
  public map: any;
  public contadorSegmentos: number = 0;
  public arregloCoordenadasElemento: Array<Coordenada[]> = new Array<
    Coordenada[]
  >();
  public catEstados$: Observable<Estado[]>;
  public catDireccionesAdjuntas$: Observable<ElementoCatalogo[]>;
  public catTipoObra$: Observable<ElementoCatalogo[]>;
  public catColores: ElementoCatalogo[];
  public readonly LEVANTAMIENTO_WEB: string = "1";
  public readonly OBRA_PENDIENTE_POR_VALIDAR: string = "0";
  public readonly OBRA_EN_PROCESO: string = "0";
  public readonly OBRA_EN_PLANEACION: string = "1";
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";

  public KEY_COLOR_CAPA_PROYECTO_PROCESO: string = "0";
  public KEY_COLOR_CAPA_PROYECTO_PLANEACION: string = "4";
  public HEX_COLOR_CAPA_PROYECTO_PROCESO: string = "";
  public HEX_COLOR_CAPA_PROYECTO_PLANEACION: string = "";

  public readonly fechaActual: number = new Date().getTime();

  public coordenadaCentral: Coordenada;
  public coordenadaInicial: Coordenada;
  public coordenadaFinal: Coordenada;

  public iconoCoordenada: any = {
    url: "../../../../../assets/img/iconos/coordenada-disponible.png",
    scaledSize: {
      width: 5,
      height: 5,
    },
  };

  public iconoInicioFin: any;
  public datosCargados: boolean = false;
  public longitud: number = 0;
  public levantamientoObraBackend: LevantamientoObra;
  public capaBackend: Capa;
  public segmentoBackend: Segmento;

  public constructor(
    private dateUtils: DateUtils,
    private mapUtils: MapUtils,
    private formBuilder: FormBuilder,
    private catalogoService: CatalogoService,
    private facadeSesionService: FacadeSesionService,
    private levantamientoObraService: LevantamientoObraService,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private loaderService: LoaderService,
    private alertasService: AlertasService,
    private cd: ChangeDetectorRef,
    private mapsAPILoader: MapsAPILoader
  ) {}

  public async ngOnInit() {
    await this.mapsAPILoader.load();
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Levantamiento de obra"
    );
    this.facadeSesionService.usuarioEnSesionService
      .obtenerUsuario()
      .subscribe(
        (usuarioSesionDTO: UsuarioSesionDTO) =>
          (this.usuarioEnSesion = usuarioSesionDTO)
      );
    this.cargarCatalogos();
    this.inicializarForm();
    this.idiomaCalendario = this.dateUtils.idiomaEspanol;
    this.iconoInicioFin = {
      url: "../../../../../assets/img/iconos/marker-red.png",
      scaledSize: {
        width: 25,
        height: 25,
      },
      labelOrigin: new google.maps.Point(0, 0),
    };

    this.datosCargados = true;
    this.cd.detectChanges();
  }

  public inicializarForm(): void {
    this.form = this.formBuilder.group({
      nombreObra: new FormControl("", [Validators.required]),
      keyCatDireccionAdjunta: new FormControl("-1", [
        Validators.required,
        this.validarId,
      ]),
      keyCatTipoObra: new FormControl("-1", [
        Validators.required,
        this.validarId,
      ]),
      keyCatEstado: new FormControl("-1", [
        Validators.required,
        this.validarId,
      ]),
      nombreTramoLicitacion: new FormControl("", [Validators.required]),
      fechaRegistro: new FormControl(null, [Validators.required]),
    });
  }

  public async cargarCatalogos(): Promise<void> {
    this.catEstados$ = this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1));
    this.catDireccionesAdjuntas$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1));
    this.catTipoObra$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1));
    this.catColores = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.HEX_COLOR_CAPA_PROYECTO_PROCESO = this.catColores.find(
      (c: ElementoCatalogo) => c.key === this.KEY_COLOR_CAPA_PROYECTO_PROCESO
    ).nombre;
    this.HEX_COLOR_CAPA_PROYECTO_PLANEACION = this.catColores.find(
      (c: ElementoCatalogo) => c.key === this.KEY_COLOR_CAPA_PROYECTO_PLANEACION
    ).nombre;
  }

  public mapReady(event: any): void {
    this.map = event;
    this.centrarTrazo();
  }

  public eliminarArchivo(indice: number): void {
    this.archivos.splice(indice, 1);
  }

  public async cargarMapa(): Promise<any> {
    this.arregloCoordenadasElemento = await this.obtenerCoordsDeArchivoKMZ();
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.arregloCoordenadasElemento)
    );
    this.cd.detectChanges();
  }

  public crearArregloPolylines(coordenadasElemento: Array<Coordenada[]>): any {
    return coordenadasElemento.map((coordenadas: Coordenada[]) =>
      this.crearPolyline(coordenadas)
    );
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map((p) => ({
        lat: p.latitud,
        lng: p.longitud,
      })),
    };
  }

  public centrarTrazo(): void {
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.arregloCoordenadasElemento)
    );
  }

  public async crearLevantamientoWeb(): Promise<any> {
    try {
      this.loaderService.activarLoaderScreen();
      let levantamientoObra = await this.crearLevantamientoObra();
      // await this.guardarLevantamientoBackend(
      //   levantamientoObra.key,
      //   this.levantamientoObraBackend
      // );
      let capa = await this.crearCapa(levantamientoObra.key);
      // await this.guardarCapaBackend(capa.key, this.capaBackend).then(
      //   () => {
      //     console.log("Capa guardada correctamente en el servidor!");
      //   },
      //   (err) =>
      //     console.log(
      //       "Hubo un error al intentar guardar la capa en el servidor!"
      //     )
      // );
      let arregloCoordenadasElemento: Array<Coordenada[]> =
        await this.obtenerCoordsDeArchivoKMZ();
      for (let index = 0; index < arregloCoordenadasElemento.length; index++) {
        await this.crearSegmento(capa.key, arregloCoordenadasElemento[index]);
        // await this.guardarSegmentoBackend(
        //   capa.key,
        //   arregloCoordenadasElemento[index]
        // ).then(
        //   () => {
        //     console.log("Segmento guardado correctamente en el servidor!");
        //   },
        //   (err) =>
        //     console.log(
        //       "Hubo un error al intentar guardar el segmento en servidor!"
        //     )
        // );
      }
      this.alertasService.mostrarAlerta(
        "success",
        "Se ha creado el levantamiento de obra con éxito."
      );
    } catch (err) {
      this.alertasService.mostrarAlerta(
        "error",
        "Error al crear levantamiento de obra.",
        err
      );
      console.error("Error al crear el levantamiento de obra", err);
    } finally {
      this.loaderService.desactivarLoaderScreen();
    }
  }

  public crearLevantamientoObra(): Promise<any> {
    let levantamientoObra: LevantamientoObra = {
      nombreObra: this.form.get("nombreObra").value,
      keyCatDireccionAdjunta: this.form.get("keyCatDireccionAdjunta").value,
      keyCatTipoObra: this.form.get("keyCatTipoObra").value,
      keyCatEstado: this.form.get("keyCatEstado").value,
      nombreTramoLicitacion: this.form.get("nombreTramoLicitacion").value,
      keyUsuarioLevantamiento: this.usuarioEnSesion.usuario.key,
      keyCatTipoLevantamiento: this.LEVANTAMIENTO_WEB,
      keyCatEstatusValidacionObra: this.OBRA_PENDIENTE_POR_VALIDAR,
      fechaRegistro: (this.form.get("fechaRegistro").value as Date).getTime(),
      fechaCreacion: this.fechaActual,
      fechaActualizacion: this.fechaActual,
      fechaAprobacion: 0,
      latitud: this.coordenadaCentral.latitud,
      longitud: this.coordenadaCentral.longitud,
    };
    this.levantamientoObraBackend = levantamientoObra;
    return this.levantamientoObraService.save(levantamientoObra);
  }

  guardarLevantamientoBackend(key, levantamientoObra) {
    const levantamientoBackend: LevantamientoObra = {
      key: key,
      ...levantamientoObra,
    };
    console.log(levantamientoBackend);
    this.levantamientoObraService.save2(levantamientoBackend).then(
      () => {
        console.log("Levantamiento guardado correctamente en el servidor!");
      },
      (err) =>
        console.log(
          "Hubo un error al intentar guardar el levantamiento en el servidor!"
        )
    );
  }

  public async crearCapa(keyLevantamientoObra: string): Promise<any> {
    let capa: Capa = {
      keyLevantamientoObra,
      keyCatCapa:
        this.form.get("keyCatTipoObra").value === this.OBRA_EN_PROCESO
          ? this.CAPA_PROYECTO_PROCESO
          : this.CAPA_PROYECTO_PLANEACION,
      fechaCreacion: this.fechaActual,
      fechaActualizacion: this.fechaActual,
      keyUsuarioCreacion: this.usuarioEnSesion.usuario.key,
    };
    console.log(capa);
    this.capaBackend = capa;
    return this.capaService.save(capa);
  }

  guardarCapaBackend(key, capa) {
    const capaBackend: Capa = {
      key: key,
      ...capa,
    };
    console.log(capaBackend);
    return this.capaService.save2(capaBackend);
  }

  public async crearSegmento(
    keyCapa: string,
    coordenadas: Coordenada[]
  ): Promise<any> {
    let segmento: Segmento = {
      keyCapa,
      keyCatColor:
        this.form.get("keyCatTipoObra").value === this.OBRA_EN_PROCESO
          ? this.KEY_COLOR_CAPA_PROYECTO_PROCESO
          : this.KEY_COLOR_CAPA_PROYECTO_PLANEACION,
      fechaCreacion: this.fechaActual,
      fechaActualizacion: this.fechaActual,
      keyUsuarioCreacion: this.usuarioEnSesion.usuario.key,
      coordenadas,
      longitud: await this.mapUtils.obtenerLongitudSegmento(coordenadas),
    };
    return this.segmentoService.save(segmento);
  }

  async guardarSegmentoBackend(
    keyCapa: string,
    coordenadas: Coordenada[]
  ): Promise<any> {
    let segmento: Segmento = {
      keyCapa,
      keyCatColor:
        this.form.get("keyCatTipoObra").value === this.OBRA_EN_PROCESO
          ? this.KEY_COLOR_CAPA_PROYECTO_PROCESO
          : this.KEY_COLOR_CAPA_PROYECTO_PLANEACION,
      fechaCreacion: this.fechaActual,
      fechaActualizacion: this.fechaActual,
      keyUsuarioCreacion: this.usuarioEnSesion.usuario.key,
      coordenadas,
      longitud: await this.mapUtils.obtenerLongitudSegmento(coordenadas),
    };
    console.log(segmento);
    return this.segmentoService.save2(segmento);
  }

  public async obtenerCoordsDeArchivoKMZ(): Promise<Array<Coordenada[]>> {
    let promesasKml: Promise<any>[] = this.obtenerPromesasDeKml(this.archivos);
    let kmls = await Promise.all(promesasKml);
    let arregloGeoJson = this.crearArregloGeoJson(kmls);
    let segmentos: Array<Coordenada[]> = new Array<Coordenada[]>();
    let contadorSegmentos: number = 0;
    arregloGeoJson[0].features.forEach((feature) => {
      if (feature.geometry.type === "LineString") {
        let coordenadas: Coordenada[] = [];
        feature.geometry.coordinates.forEach((coordinate) => {
          let coordenadaElemento: Coordenada = {
            latitud: coordinate[1],
            longitud: coordinate[0],
          };
          coordenadas.push(coordenadaElemento);
        });
        segmentos.push(coordenadas);
        contadorSegmentos++;
      }
    });
    this.contadorSegmentos = contadorSegmentos;
    this.coordenadaCentral =
      this.mapUtils.obtenerCoordenadaCentralArregloPolylines(segmentos);
    this.coordenadaInicial =
      this.mapUtils.obtenerCoordenadaInicialArregloPolylines(segmentos);
    this.coordenadaFinal =
      this.mapUtils.obtenerCoordenadaFinalArregloPolylines(segmentos);
    this.longitud = await this.mapUtils.obtenerLongitudArreglosCoordenadas(
      segmentos
    );

    return segmentos;
  }

  private validarId(control: AbstractControl) {
    return control.value === "-1" ? { error: "El campo es requerido" } : null;
  }

  public crearArregloGeoJson(kmls): any {
    return kmls.map((kmlDom) => toGeoJSON.kml(kmlDom));
  }

  public obtenerPromesasDeKml(archivosKmz: any[]): Promise<any>[] {
    return archivosKmz.map((archivo) => this.obtenerXmlDeKML(archivo));
  }

  public obtenerXmlDeKML(archivoKmz: any): Promise<any> {
    var zip = new JSZip();
    return zip.loadAsync(archivoKmz).then((zip) => {
      let kmlDom = null;
      zip.forEach((rutaArchivo, file) => {
        if (
          this.obtenerExtensionArchivo(rutaArchivo) === "kml" &&
          kmlDom === null
        ) {
          kmlDom = file.async("string").then(this.convertirStringToXML);
        }
      });
      return kmlDom || Promise.reject("No se encontro archivo kml");
    });
  }

  public convertirStringToXML(xml: string): Document {
    return new DOMParser().parseFromString(xml, "text/xml");
  }

  public obtenerExtensionArchivo(rutaArchivo: string) {
    return rutaArchivo.split(".").pop();
  }

  public cargarArchivos(archivos: FileList): void {
    this.archivos[0] = archivos[0];
    this.cargarMapa();
  }

  public obtenerMensajeValidacion(controlName: string): string {
    let error = "";
    const control = this.form.get(controlName);
    if (
      (control.touched && control.errors != null) ||
      (control.touched && control.value === "-1")
    ) {
      error = "El campo es requerido";
    }
    return error;
  }
}
